export const THEME_LIGHT = 'light';
export const THEME_BLUE = 'blue';
export const LC_THEME_KEY = 'keep.theme';
